import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        userCode: this.paramsProps.userCode,
      },
    };
  },
  methods: {

  },
  created() {
    this.getConfigList('detail-list');
  },
};
